<div id="recommend-multimedia" class="m-3">
    <h1 class="mb-3">Recomendar multimedia</h1>

    <label for="multimedia-type-select" class="d-inline-block me-3 mb-3">
        <p class="fw-bold">Tipos de multimedia a recomendar:</p>
        <select name="multimedia-type-select" id="multimedia-type-select"
            [(ngModel)]="type" (ngModelChange)="reset()">
            <option value="image">Imágenes</option>
            <option value="video">Vídeos</option>
        </select>
    </label>

    <label for="multimedia-keywords-input" class="d-inline-block me-3 mb-3">
        <p class="fw-bold">Palabras clave (separadas por comas):</p>
        <input type="text" class="form-control" name="multimedia-keywords-input" id="multimedia-keywords-input" [(ngModel)]="keywords">
    </label>

    <label for="multimedia-max-result-input" class="d-inline-block me-3 mb-3">
        <p class="fw-bold">Número máximo de resultados:</p>
        <input type="number" min="5" [attr.max]="type === 'image' ? 10 : 50" [(ngModel)]="maxResults">
    </label>

    <label for="multimedia-image-type-select" class="d-inline-block me-3 mb-3" *ngIf="type === 'image'">
        <p class="fw-bold">Tipo de imágenes a buscar:</p>
        <select name="multimedia-image-type-select" id="multimedia-image-type-select" [(ngModel)]="imageType">
            <option value="imgTypeUndefined">Sin definir</option>
            <option value="clipart">clipart</option>
            <option value="face">Caras (face)</option>
            <option value="lineart">lineart</option>
            <option value="stock">Genéricas (stock)</option>
            <option value="photo">Fotos (photo)</option>
            <option value="animated">Animadas (animated)</option>
        </select>
    </label>

    <label for="multimedia-image-color-select" class="d-inline-block me-3 mb-3" *ngIf="type === 'image'">
        <p class="fw-bold">Color de las imágenes:</p>
        <select name="multimedia-image-color-select" id="multimedia-image-color-select" [(ngModel)]="imageColor">
            <option value="color">Color</option>
            <option value="gray">Escala de grises</option>
            <option value="mono">Blanco y negro</option>
            <option value="trans">Fondo transparente</option>
        </select>
    </label>

    <label for="multimedia-video-order-select" class="d-inline-block me-3 mb-3" *ngIf="type === 'video'">
        <p class="fw-bold">Orden:</p>
        <select name="multimedia-video-order-select" id="multimedia-video-order-select" [(ngModel)]="videoOrder">
            <option value="relevance">Relevancia</option>
            <option value="date">Fecha de creación</option>
            <option value="rating">Calificación</option>
            <option value="title">Título</option>
            <option value="viewCount"># de reproducciones</option>
        </select>
    </label>

    <div id="get-multimedia-buttons" class="d-block mb-3">
        <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active" *ngIf="!dialog">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success me-3" [attr.disabled]="getMultimediaLoading ? 'disabled' : null" (click)="getMultimedia()">
            <i class="fa fa-search"></i>
            <i class="fas fa-photo-video"></i>
            <span>Buscar multimedia</span>
        </button>
    </div>

    <div id="get-multimedia-result" class="text-center mb-3">
        <div id="get-multimedia-loading" *ngIf="getMultimediaLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Buscando multimedia, espere, por favor...</span>
        </div>
        <div id="get-multimedia-error" class="text-danger" *ngIf="getMultimediaError">
            <i class="fa fa-times"></i>
            <span>{{ getMultimediaErrorMsg }}</span>
        </div>
        <div id="get-multimedia-success" class="text-success" *ngIf="getMultimediaSuccess">
            <i class="fa fa-check"></i>
            <span>Se ha encontrado multimedia. Abajo podrá previsualizar los elementos encontrados y elegir cuáles quiere agregar al curso.</span>
        </div>
    </div>

    <div id="multimedia-items" *ngIf="getMultimediaSuccess">
        <ul id="multimedia-images" *ngIf="multimediaImages.length > 0">
            <li *ngFor="let image of multimediaImages; let i = index;" [ngClass]="{'selected' : multimediaIndexInList('image', image) > -1}">
                <label class="d-block">
                    <img *ngIf="image.thumb" class="my-3" [width]="image.thumb.width" [height]="image.thumb.height" [src]="image.thumb.link" [alt]="image.title" [title]="image.title">
                    <img *ngIf="!image.thumb" class="my-3" [width]="image.width" [height]="image.height" [src]="image.link" [alt]="image.title" [title]="image.title">
                    <p>Imagen #{{ image.num }}</p>
                    <p class="image-title">Título: {{ image.title }}</p>
                    <p class="image-format">Formato: {{ image.ext }}</p>
                    <p class="image-size">Tamaño: {{ image.size.kb }} KB</p>
                    <p class="image-dimensions">Dimensiones: {{ image.width }} x {{ image.height }}</p>
                    <!-- <p class="image-similarity">Similitud: {{ image.similarity }}%</p> -->
                    <div>
                        <a class="btn btn-primary m-3" title="Ver (Para descargar, haz clic derecho y selecciona 'Guardar enlace como...')" [href]="image.link" target="_blank">
                            <i class="fa fa-eye"></i>
                        </a>
                    </div>
                    <div class="mb-2">
                        <input type="checkbox" [attr.checked]="multimediaIndexInList('image', image) > -1 ? 'checked' : null" (change)="multimediaList('image', image)">
                        <span class="fw-bold ms-3">Seleccionar para añadir</span>
                    </div>
                </label>
            </li>
        </ul>

        <ul id="multimedia-videos" *ngIf="multimediaVideos.length > 0">
            <li *ngFor="let video of multimediaVideos; let v = index;">
                <!--
                <a [href]="video.link">
                    <img class="video-thumbnail my-4" [src]="video.thumbnail.url" [alt]="video.title" title="Clic para ver vídeo en YouTube">
                </a>
                -->
                <img class="video-thumbnail my-4" [src]="video.thumbnail" [alt]="video.title">
                <!-- <iframe width="500" height="300" frameborder="0" [src]="video.link" [title]="video.title"></iframe> -->
                <p>Vídeo #{{ video.num }}</p>
                <p class="video-title">Título: {{ video.title }}</p>
                <!-- <p class="video-description">Descripción: {{ video.description }}</p> -->
                <p class="video-channel">Canal: {{ video.channel }}</p>
                <p class="video-publish-date">Publicado: {{ video.date }}</p>
                <div>
                    <a class="btn btn-primary m-3" title="Ver en YouTube" [href]="video.watch" target="_blank">
                        <i class="fa fa-eye"></i>
                    </a>
                </div>
                <label class="d-block mb-2">
                    <input type="checkbox" (click)="multimediaList('video', video)">
                    <span class="fw-bold ms-3">Seleccionar para añadir</span>
                </label>
                <!--
                <label class="d-block mb-2" *ngIf="multimediaIndexInList('video', video) > -1">
                    <input type="checkbox" [(ngModel)]="video.download">
                    <span class="ms-3">Descargar vídeo</span>
                </label>
                -->
            </li>
        </ul>
    </div>

    <div id="multimedia-destination" *ngIf="mode == 'lesson' && getMultimediaSuccess">
        <p class="fw-bold">Seleccione la lección del curso a la cual asignar la multimedia:</p>
        
        <label for="course-units" class="d-block mb-3" *ngIf="units">
            <p class="fw-bold">Unidad:</p>
            <select name="course-units" id="course-units" [(ngModel)]="unitID"
                (ngModelChange)="selectUnit($event)">
                <option disabled selected value="0">Seleccione una unidad...</option>
                <option *ngFor="let unit of units" value="{{ unit.id }}">
                    {{ unit.name }}
                </option>
            </select>
        </label>
    
        <label for="units-lessons" class="d-block mb-3" *ngIf="lessons">
            <p class="fw-bold">Lección:</p>
            <select name="unit-lessons" id="unit-lessons" [(ngModel)]="lessonID">
                <option disabled selected value="0">Seleccione una lección...</option>
                <option *ngFor="let lesson of lessons" value="{{ lesson.id }}">
                    {{ lesson.name }}
                </option>
            </select>
        </label>
    </div>

    <div id="add-multimedia-buttons" *ngIf="getMultimediaSuccess">
        <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active" *ngIf="!dialog">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>

        <button class="btn btn-success me-3" [attr.disabled]="addMultimediaLoading ? 'disabled' : null" (click)="addMultimedia()">
            <i class="fa fa-plus"></i>
            <i class="fas fa-photo-video"></i>
            <span>Añadir multimedia</span>
        </button>
    </div>

    <div id="add-multimedia-result" class="form-group text-center">
        <div id="add-multimedia-loading" *ngIf="addMultimediaLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Añadiendo multimedia, espere, por favor...</span>
        </div>
        <!--
        <div id="add-multimedia-error" class="text-danger" *ngIf="addMultimediaError">
            <i class="fa fa-times"></i>
            <span>Hubo un error, no se añadió la multimedia. Por favor, inténtelo de nuevo.</span>
        </div>
        -->
        <!--
        <div id="add-multimedia-success" class="text-success" *ngIf="addMultimediaSuccess">
            <i class="fa fa-check"></i>
            <span>Se ha añadido la multimedia a la lección. Si ha seleccionado vídeos para descargar, se están descargando en segundo plano.</span>
        </div>
        -->

        <div id="add-multimedia-results" *ngIf="result.length > 0">
            <p>Resultado:</p>
            <ul>
               <li *ngFor="let item of result" [ngClass]="{'text-danger' : item.error, 'text-success' : !item.error}">
                    <i class="fas fa-check" *ngIf="!item.error"></i>
                    <i class="fas fa-times" *ngIf="item.error"></i>
                    <span>Imagen {{ item.num }}: {{ item.message }}</span>
               </li>
            </ul>
        </div>
    </div>
</div>